/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
import { colors } from "../../theme";

const RadioGroup = ({ children, direction }) => (
    <div
        css={css`
            display: flex;
            flex-direction: ${direction === "row" ? "row" : "column"};
            & div {
                margin-bottom: 10px;
            }
            & label {
                margin-left: 8px;
                ${direction === "row" && "margin-right: 8px;"}
            }
            & input[type="radio"] {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                position: relative;
                background-color: ${colors.neutral0};
                top: 2px;
                height: 16px;
                width: 16px;
                border: 1px solid ${colors.neutral4};
                border-radius: 16px;
                cursor: pointer;
                outline: none;
            }
            & input[type="radio"]:checked:after {
                content: "";
                position: absolute;
                left: 3px;
                top: 3px;
                width: 8px;
                height: 8px;
                border-radius: 8px;
                background-color: ${colors.primary6};
            }
        `}
    >
        {children}
    </div>
);

export default RadioGroup;
